<ng-container *msShowInEpcot="{ showInEpcot: true, module: module }">
    <div class="betslip-over-ask-maxstake-content-epcot">
        <ms-epcot-notification
            [message]="device.isMobile && !device.isTablet ? messages.stakeChangeMobileBody : messages.stakeChangeDesktopBody"
            [notificationType]="'info'" />
    </div>
</ng-container>
<ng-container *msShowInEpcot="{ showInEpcot: false, module: module }">
    <div class="betslip-over-ask-maxstake-content">
        <span class="betslip-over-ask-maxstake__icon theme-info-i"></span>
        <span
            class="betslip-over-ask-maxstake__message"
            [innerHtml]="device.isMobile && !device.isTablet ? messages.stakeChangeMobileBody : messages.stakeChangeDesktopBody"></span>
    </div>
</ng-container>
